import axios from 'axios';
import { Controller } from 'src/models/controller';
import APIS from '../apiUrl';
import { requireAuthHeaders } from '../auth/getAuthToken';

/**
 * Updates the controller in the sentinel system with the provided information.
 * @param controllerId The controller to update.
 * @param data The date about the controller to update.
 * @returns The new controller object.
 */
export const updateController = async (
  controllerId: string,
  data: Partial<Omit<Controller, '_id'>>,
): Promise<Controller> => {
  const response = await axios.post<Controller>(
    `${APIS.SENTINEL_API}/api/controllers/update`,
    {
      _id: controllerId,
      update: { $set: data },
    },
    {
      headers: await requireAuthHeaders(),
    },
  );

  return response.data;
};
